export enum VALIDATION {
  VALID = 'valid',
  INVALID = 'invalid',
  PARTIALLY_VALID = 'partial',
  NA = 'n/a',
  NOTHING = 'nothing',
}
